require('../export');

ya.music.Audio.fx.Equalizer = require('./equalizer');
